import { blue, gold, gray, orange } from "@ant-design/colors";
import { Button, Modal, Typography } from "antd";
import Prefixs from "common/Prefixs";
import { formatDateTimeDMY } from "helpers/formatDate";
import { useHistory } from "react-router-dom";

export default function ModalExtendNotify({ isOpen, setIsOpen, dataInfoCert }) {
  const history = useHistory();

  const handleOk = () => {
    history.push(`${Prefixs.COMPENSATION_EXTEND}?type=${dataInfoCert?.type}`);
  };
  const handleCancel = () => {
    history.push(Prefixs.RENEWCERT_INFO);
  };

  return (
    <Modal
      title="Thông báo gia hạn"
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={[
        <Button
          key="back"
          type="primary"
          onClick={handleCancel}
          style={{ background: gold.primary }}
        >
          Tiếp tục cấp bù
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          Gia hạn
        </Button>,
      ]}
    >
      <div className="text-center">
        <div>
          Thời hạn dịch vụ của Quý khách hàng còn hạn đến:{" "}
          <Typography.Text strong type="danger" style={{ fontSize: "1.1rem" }}>
            {formatDateTimeDMY(dataInfoCert?.certificateEnd)}
          </Typography.Text>
        </div>
        <div></div>
        {/* <br/> */}
        <div>
          Anh chị muốn gia hạn dịch vụ với
          <Typography.Text
            strong
            type="primary"
            style={{ color: blue.primary }}
          >
            {" "}
            Giá ưu đãi{" "}
          </Typography.Text>
          của nhà cung cấp vui lòng nhấn
          <Typography.Text
            strong
            type="primary"
          >
            “Gia hạn”
          </Typography.Text>
          để thực hiện.
        </div>
      </div>
    </Modal>
  );
}
